import API, { graphqlOperation } from "@aws-amplify/api"
import {
	createLayoutDetails as createLayoutDetailsGql,
	updateLayoutDetails as updateLayoutDetailsGql,
	createMasterLocation as createMasterLocationGql,
	updateMasterLocation as updateMasterLocationGql,
	updateNodeLocations as updateNodeLocationsGql,
	updateNodeId as updateNodeIdGql,
	updateMasterId as updateMasterIdGql,
	createReplacementCampaignInfo as createReplacementCampaignInfoGql,
	deleteReplacementCampaignInfo as deleteReplacementCampaignInfoGql,
	createTask as createTaskGql,
} from "graphql/mutations"
import * as actionTypes from "./types"
import offlineStorage from "offlineStorage"

export const createLayoutDetails =
	(name, layoutDetails = {}) =>
	async (dispatch) => {
		// TODO: update indexedDB
		const { data } = await API.graphql(
			graphqlOperation(createLayoutDetailsGql, {
				input: { name, ...layoutDetails },
			}),
		)
		console.log(data)
		if (data) {
			const { createLayoutDetails } = data
			if (createLayoutDetails) {
				await dispatch({
					type: actionTypes.UPDATE_LAYOUT_DETAILS,
					layoutDetails: createLayoutDetails,
				})
				return createLayoutDetails
			}
		} else {
			return false
		}
	}

export const updateLayoutDetails =
	(layoutId, layoutDetails = {}) =>
	async (dispatch) => {
		// TODO: update indexedDB
		const { data } = await API.graphql(
			graphqlOperation(updateLayoutDetailsGql, {
				input: { id: layoutId, ...layoutDetails },
			}),
		)
		console.log(data)
		if (data) {
			const { updateLayoutDetails } = data
			if (updateLayoutDetails) {
				await dispatch({
					type: actionTypes.UPDATE_LAYOUT_DETAILS,
					layoutDetails: updateLayoutDetails,
				})
				return updateLayoutDetails
			}
		} else {
			return false
		}
	}

export const createMasterDetails =
	(layoutId, name, masterDetails = {}) =>
	async (dispatch) => {
		// TODO: update indexedDB

		const { data } = await API.graphql(
			graphqlOperation(createMasterLocationGql, {
				input: { layoutId, name, ...masterDetails },
			}),
		)
		console.log(data)
		if (data) {
			const { createMasterLocation } = data
			if (createMasterLocation) {
				await dispatch({
					type: actionTypes.UPDATE_MASTER_DETAILS,
					masterDetails: createMasterLocation,
				})
				return createMasterLocation
			}
		} else {
			return false
		}
	}

export const createTask = (input) => async (dispatch, getState) => {
	const { user } = getState()

	const { mLocId, timestamp } = input

	const createTaskInput = {
		userId: user.id,
		username: `${user.nameFirst} ${user.nameLast}`,
		...input,
	}

	try {
		const result = await API.graphql(
			graphqlOperation(createTaskGql, {
				input: {
					userId: user.id,
					username: `${user.nameFirst} ${user.nameLast}`,
					...input,
				},
			}),
		)
		console.log(result)
		return true
	} catch (err) {
		if (err.errors.reduce((acc, curr) => curr.message === "Network Error" || acc, false)) {
			console.log("Network Error => SAVE TO CACHE")
			await (await offlineStorage).put("taskChanges", createTaskInput, `${mLocId}#${timestamp}`)
		} else {
			console.error(err)
		}
		return false
	}
}

export const updateMasterDetails =
	(mLocId, layoutId, masterDetails = {}) =>
	async (dispatch) => {
		// TODO: update indexedDB
		console.log({
			input: { id: mLocId, layoutId, ...masterDetails },
		})
		const { data } = await API.graphql(
			graphqlOperation(updateMasterLocationGql, {
				input: { id: mLocId, layoutId, ...masterDetails },
			}),
		)
		console.log(data)
		if (data) {
			const { updateMasterLocation } = data
			if (updateMasterLocation) {
				await dispatch({
					type: actionTypes.UPDATE_MASTER_DETAILS,
					masterDetails: updateMasterLocation,
				})
				return updateMasterLocation
			}
		} else {
			return false
		}
	}

export const updateNodeLocations =
	(mLocId, layoutId, details = {}) =>
	async (dispatch) => {
		// TODO: update indexedDB
		console.log("updateNodeLocations", { mLocId, layoutId, ...details })
		const { data } = await API.graphql(
			graphqlOperation(updateNodeLocationsGql, {
				input: { mLocId, layoutId, ...details },
			}),
		)
		console.log(data)
		if (data) {
			const { updateNodeLocations } = data
			if (updateNodeLocations) {
				await dispatch({
					type: actionTypes.UPDATE_NODE_DETAILS,
					nodeDetails: [updateNodeLocations],
				})
				return updateNodeLocations
			}
		} else {
			return false
		}
	}

export const setNodeId = (layoutId, mLocId, nLocId, nId) => async (dispatch, getState) => {
	const { layoutDetails, masterDetails, user } = getState()
	const updateNodeIdInput = {
		layoutId,
		mLocId,
		mId: masterDetails[mLocId].mId || "",
		timestamp: Math.round(new Date().getTime() / 1000),
		userId: user.id,
		username: `${user.nameFirst} ${user.nameLast}`,
		masterName: masterDetails[mLocId].name,
		layoutName: layoutDetails[layoutId].name,
		nLocId,
		nId,
	}

	await dispatch({
		type: actionTypes.UPDATE_NODE_ID,
		mLocId,
		nLocId,
		nId,
		status: "pendingUpload",
	})

	try {
		const result = await API.graphql(
			graphqlOperation(updateNodeIdGql, {
				input: updateNodeIdInput,
			}),
		)
		console.log(result)
		return true
	} catch (err) {
		if (err.errors.reduce((acc, curr) => curr.message === "Network Error" || acc, false)) {
			console.log("Network Error => SAVE TO CACHE")
			await (await offlineStorage).put("nodeIdChanges", updateNodeIdInput, `${mLocId}#${nLocId}`)
			dispatch({
				type: actionTypes.SET_WIZARD_INFO,
				info: {
					error: "Network Error",
				},
			})
		} else {
			console.error(err)
		}
		return false
	}
}

export const setMasterId = (layoutId, mLocId, mId) => async (dispatch, getState) => {
	const { layoutDetails, masterDetails, user } = getState()
	const updateMasterIdInput = {
		layoutId,
		mLocId,
		mId,
		timestamp: Math.round(new Date().getTime() / 1000),
		userId: user.id,
		username: `${user.nameFirst} ${user.nameLast}`,
		masterName: masterDetails[mLocId].name,
		layoutName: layoutDetails[layoutId].name,
	}

	await dispatch({
		type: actionTypes.UPDATE_MASTER_ID,
		mLocId,
		mId,
		status: "pendingUpload",
	})

	try {
		const result = await API.graphql(
			graphqlOperation(updateMasterIdGql, {
				input: updateMasterIdInput,
			}),
		)
		console.log(result)
		return true
	} catch (err) {
		if (err.errors.reduce((acc, curr) => curr.message === "Network Error" || acc, false)) {
			console.log("Network Error => SAVE TO CACHE")
			await (await offlineStorage).put("masterIdChanges", updateMasterIdInput, mLocId)
		} else {
			console.error(err)
		}
		return false
	}
}

export const loadCachedNodeIdChanges = () => async (dispatch) => {
	const nodeIdChanges = await (await offlineStorage).getAll("nodeIdChanges")
	const dispatchPromises = nodeIdChanges.map((updateNodeIdInput) => {
		const { mLocId, nLocId, nId } = updateNodeIdInput

		return dispatch({
			type: actionTypes.UPDATE_NODE_ID,
			mLocId,
			nLocId,
			nId,
			status: "pendingUpload",
		})
	})
	await Promise.all(dispatchPromises)

	for (let i = 0; i < nodeIdChanges.length; i++) {
		const updateNodeIdInput = nodeIdChanges[i]
		const { mLocId, nLocId, nId } = updateNodeIdInput
		try {
			const { data } = await API.graphql(
				graphqlOperation(updateNodeIdGql, {
					input: updateNodeIdInput,
				}),
			)
			console.log(data, updateNodeIdInput)
			if (data && data["updateNodeId"]) {
				await (await offlineStorage).delete("nodeIdChanges", `${mLocId}#${nLocId}`)
				await dispatch({
					type: actionTypes.UPDATE_NODE_ID,
					mLocId,
					nLocId,
					nId,
					status: "accepted",
				})
			}
		} catch (err) {
			if (err.errors.reduce((acc, curr) => curr.message === "Network Error" || acc, false)) {
				console.log("Network Error on re-attempted nId upload")
			} else {
				console.error(err)
			}
		}
	}
}

export const loadCachedMasterIdChanges = () => async (dispatch) => {
	const masterIdChanges = await (await offlineStorage).getAll("masterIdChanges")
	const dispatchPromises = masterIdChanges.map((updateMasterIdInput) => {
		const { mLocId, mId } = updateMasterIdInput

		return dispatch({
			type: actionTypes.UPDATE_MASTER_ID,
			mLocId,
			mId,
			status: "pendingUpload",
		})
	})
	await Promise.all(dispatchPromises)

	for (let i = 0; i < masterIdChanges.length; i++) {
		const updateMasterIdInput = masterIdChanges[i]
		const { mLocId, mId } = updateMasterIdInput

		try {
			const { data } = await API.graphql(
				graphqlOperation(updateMasterIdGql, {
					input: updateMasterIdInput,
				}),
			)
			console.log(data, updateMasterIdInput)
			if (data && data["updateMasterId"]) {
				await (await offlineStorage).delete("masterIdChanges", mLocId)
				await dispatch({
					type: actionTypes.UPDATE_MASTER_ID,
					mLocId,
					mId,
					status: "accepted",
				})
			}
		} catch (err) {
			if (err.errors.reduce((acc, curr) => curr.message === "Network Error" || acc, false)) {
				console.log("Network Error on re-attempted mId upload")
			} else {
				console.error(err)
			}
		}
	}
}

export const loadCachedTaskChanges = () => async (dispatch) => {
	//console.log("Uploading Cached Tasks")
	const taskChanges = await (await offlineStorage).getAll("taskChanges")

	for (let i = 0; i < taskChanges.length; i++) {
		const createTaskInput = taskChanges[i]
		const { mLocId, timestamp } = createTaskInput

		try {
			const { data } = await API.graphql(
				graphqlOperation(createTaskGql, {
					input: createTaskInput,
				}),
			)
			console.log(data, createTaskInput)
			if (data && data["createTask"]) {
				await (await offlineStorage).delete("taskChanges", `${mLocId}#${timestamp}`)
			}
		} catch (err) {
			if (err.errors.reduce((acc, curr) => curr.message === "Network Error" || acc, false)) {
				console.log("Network Error on re-attempted upload Tasks")
			} else {
				console.error(err)
			}
		}
	}
}

export const createReplacementCampaignInfo = (layoutId, mLocId, timestamp) => async (dispatch) => {
	console.log({
		layoutId,
		mLocId,
		timestamp,
	})
	const { data } = await API.graphql(
		graphqlOperation(createReplacementCampaignInfoGql, {
			input: {
				layoutId,
				mLocId,
				timestamp,
			},
		}),
	)
	// console.log(data)
	if (data) {
		const { createReplacementCampaignInfo: info } = data
		if (info) {
			const replacementCampaignInfo = {
				[info.mLocId]: { ...info },
			}
			info["replacements"].forEach((replacement) => {
				replacementCampaignInfo[info.mLocId]["replacements"][replacement.index.toString().padStart(3, "0")] =
					replacement.id
			})
			await dispatch({
				type: actionTypes.SET_REPLACEMENT_CAMPAIGN_INFO,
				data: replacementCampaignInfo,
			})
			return createReplacementCampaignInfo
		}
	} else {
		return false
	}
}

export const deleteReplacementCampaignInfo = (layoutId, mLocId) => async (dispatch) => {
	let data
	try {
		const result = await API.graphql(
			graphqlOperation(deleteReplacementCampaignInfoGql, {
				input: {
					layoutId,
					mLocId,
				},
			}),
		)
		data = result.data
	} catch (err) {
		data = err.data
	}
	if (data) {
		const { deleteReplacementCampaignInfo: info } = data
		if (info) {
			await dispatch({
				type: actionTypes.DELETE_REPLACEMENT_CAMPAIGN_INFO,
				mLocId: info.mLocId,
			})
		}
	} else {
		return false
	}
}
